import { render, staticRenderFns } from "./CargandoInfo.vue?vue&type=template&id=0715cbd4"
import script from "./CargandoInfo.vue?vue&type=script&lang=js"
export * from "./CargandoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports